import { api } from '@core/api';

export interface RegularCompanion {
  id: number;
  name: string;
  email?: string;
  phone?: string;
  notes?: string;
  treatment?: string;
  relationship?: string;
}

export async function fetchRegularCompanions(): Promise<RegularCompanion[]> {
  const data = await api.get<{ regularCompanions: RegularCompanion[] }>('/api/regular-companions');
  return data.regularCompanions ?? [];
}
